import { combineReducers } from '@reduxjs/toolkit';
import activeLayoutTabIdReducer from './slices/active-layout-tab-id-slice';
import saveEditChangesReducer from './slices/editability/save-edit-changes';
import appEditableStateReducer from './slices/editable-view-slice';
import globalHierarchyReducer from './slices/globalFilter/GlobalFilterHierarchySlice';
import globalFilterReducer from './slices/globalFilter/global-dates-filter-slice';
import layoutTabsReducer from './slices/layout-tabs-slice';
import changesInTabOrderReducer from './slices/new-tab-order';
import selectNewTabState from './slices/new-tab-slice';
import runningJobsReducer from './slices/running-jobs';
import selectedViewReducer from './slices/selected-view';
import SidePanelReducer from './slices/side-panel-slice';
import updateWidgetTableSortFieldReducer from './slices/update-widget-table-sort-field';
import updateWidthHeightOfChartReducer from './slices/update-width-height-of-chart';
import widgetChartsStateReducer from './slices/widgetChart/WidgetChartSlice';

const rootReducer = combineReducers({
  filter: globalFilterReducer,
  filterHierarchy: globalHierarchyReducer,
  appEditability: appEditableStateReducer,
  newTabState: selectNewTabState,
  widgetChart: widgetChartsStateReducer,
  layoutTabs: layoutTabsReducer,
  layoutActiveTab: activeLayoutTabIdReducer,
  editChangesSave: saveEditChangesReducer,
  updateWidthHeight: updateWidthHeightOfChartReducer,
  tabsWeight: changesInTabOrderReducer,
  updateTableDataSettings: updateWidgetTableSortFieldReducer,
  selectedView: selectedViewReducer,
  runningJobs: runningJobsReducer,
  sidePanel: SidePanelReducer,
});

export default rootReducer;
